// Feature: Admin - API service
// Location: src/features/admin/services/adminApi.ts

import { apiClient } from 'core/api/client';
import type { PlatformDriverKycProfile } from 'types/api.generated';

export type AppRole = 'customer' | 'provider';

export interface AdminUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string | null;
  appRole: string;
  platformRole: string | null;
  isActive: boolean;
  isEmailVerified: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ListUsersResponse {
  users: AdminUser[];
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
}

export interface UpdateUserPayload {
  appRole?: AppRole;
  isActive?: boolean;
  firstName?: string;
  lastName?: string | null;
  platformRoleId?: string | null;
}

export const listUsers = async (page = 1, perPage = 20): Promise<ListUsersResponse> => {
  const res = await apiClient.get<ListUsersResponse>('/api/v1/admin/users', {
    params: { page, perPage },
  });
  return res.data;
};

export const updateUser = async (userId: string, payload: UpdateUserPayload): Promise<AdminUser> => {
  const res = await apiClient.patch<AdminUser>(`/api/v1/admin/users/${userId}`, payload);
  return res.data;
};

export const reviewVehicleVerification = async (
  vehicleId: string,
  body: { verificationStatus: 'verified' | 'rejected'; rejectionReason?: string },
): Promise<void> => {
  await apiClient.patch(`/api/v1/admin/vehicles/${vehicleId}/verification`, body);
};

export type ReviewDriverVerificationBody = {
  verificationId: string;
  verificationStatus: 'verified' | 'rejected';
  rejectionReason?: string;
};

export const reviewDriverVerification = async (
  profileId: string,
  body: ReviewDriverVerificationBody,
): Promise<void> => {
  await apiClient.patch(`/api/v1/admin/drivers/${profileId}/verification`, body);
};

export const listUserDriverVerifications = async (
  userId: string,
): Promise<PlatformDriverKycProfile[]> => {
  const { data } = await apiClient.get<PlatformDriverKycProfile[]>(
    `/api/v1/admin/users/${userId}/driver-verifications`,
  );
  return data;
};
